import React from 'react';
import { AppButton, Box, Inscription, Preloader, WarningIcon } from '@common-fe/common-fe';

import ModalWrapper from '@/components/wrappers/ModalWrapper';

interface Props {
  onSetVisible: (value: boolean) => void;
  onClose: () => void;
  onSubmit: () => void;
  isLoading?: boolean;
}

const ProvideFullAccessConfirmModal: React.FC<Props> = ({ onSetVisible, onClose, onSubmit, isLoading }) => (
  <ModalWrapper testId="provide-full-access" visible onSetVisible={onSetVisible}>
    <Box align="center">
      <WarningIcon size="48px" />

      <Inscription data-testId="provide-full-access-modal_title" margin={{ top: 'spacing12' }} size="2xl" weight={700}>
        Provide Full Access?
      </Inscription>

      <Inscription data-testId="provide-full-access-modal_subtitle" textAlign="center" margin={{ top: 'spacing12' }}>
        The employee will be automatically verified in the system without requiring any additional actions.
      </Inscription>

      <Box margin={{ top: 'spacing24' }} direction="row" width="100%" justify="center">
        <Box width={{ max: '200px', width: '100%' }}>
          <AppButton
            testId="provide-full-access-modal_close"
            onClick={onClose}
            width="100%"
            buttonType="secondary"
          >
            Close
          </AppButton>
        </Box>
        <Box width={{ max: '200px', width: '100%' }} margin={{ left: 'spacing12' }}>
          <AppButton
            testId="provide-full-access-modal_confirm"
            onClick={onSubmit}
            width="100%"
          >
            {isLoading ? <Preloader /> : 'Confirm'}
          </AppButton>
        </Box>
      </Box>
    </Box>
  </ModalWrapper>
);

export default ProvideFullAccessConfirmModal;
